/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions
     */
    SteamId: number;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions {
    if (!('SteamId' in value) || value['SteamId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'SteamId': json['SteamId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SteamId': value['SteamId'],
    };
}

